
import JobManager from './JobManager';

const Jobs: React.FC = () => <JobManager />;

export default Jobs;
